<template>
    <div class="animated fadeIn">
        <b-row class="justify-content-md-center">
            <b-col xl="6">
                <h3>Order confirmation</h3>
                <b-card class="card-confirm-success">
                    <h3>Order #{{orderData.orderId}} confirmed</h3>
                    <i class="fa fa-check" aria-hidden="true"></i>
                </b-card>
                <b-card header="Your order">
                    <p>
                        #{{orderData.orderId}} for {{orderData.volume}} Blank SIM cards has been <span class="confirmed">confirmed</span><br/>
                        and will be shipped to you in the next 7 days to the following address:
                    </p>
                    <p class="details">
                        {{orderData.shippingAddress.addressLine1}}<br/>
                        {{orderData.shippingAddress.addressLine2}}<br/>
                        {{orderData.shippingAddress.city}}<br/>
                        {{orderData.shippingAddress.state}} {{orderData.shippingAddress.postalCode}}, {{orderData.shippingAddress.country}}
                    </p>
                    <p>Shipping method: <span class="details">{{orderData.shippingOption.displayName}} - {{orderData.shippingOption.range}}</span></p>
                    <p class="carrier">
                        <span>Selected carrier: </span>
                        <strong v-if="orderData.carrier.carrierId == '1'">Simon IoT</strong>
                        <strong v-else-if="orderData.carrier.carrierId == '2'">T-Mobile</strong>
                    </p>
                    <!-- <p>Payment mehtod: <span class="details">Visa Credit Card (default)</span></p> -->
                    <p class="details">Total cost: <span class="cost">{{orderData.totalPrice.toFixed(2)}}</span></p>
                </b-card>
                <b-card>
                    <p>
                        Thank You for using Simon IoT!<br/>
                        Please feel free to contact us if you have any questions about your order or the portal.<br/>
                        <span class="details">+1-833-746-6646</span>
                    </p>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import router from "../../router";
    import Vue from 'vue'
    import globalStore from '../../variables';
    import Axios from 'axios'

    export default {
        name: "OrderConfirmed",
        data() {
            return {
                orderData: {
                    shippingAddress: {},
                    shippingOption: {}
                },
                orderId: null
            }
        },
        methods: {
            getDetailsOfOrder() {
                Axios.get(globalStore.data.restApiUrl + '/orders/' + this.orderId)
                    .then(response => {
                        if (response.status == '200') {
                            this.orderData = response.data
                            this.orderData.totalPrice = this.orderData.totalPrice.toFixed(2)
                        }
                    }).catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Getting details of order',
                            text: 'Unable to Retrieve Order Details - Contact Support',
                            duration: 5000,
                        });
                        console.log(error)
                    })
            },
            getOrderId () {
                this.orderId = this.$route.params.orderId;
            }
        },
        created() {
            this.getOrderId()
            this.getDetailsOfOrder()
        }
    }
</script>

<style lang="scss">
.card.card-confirm-success {
    background-color: #55cd6c !important;
    color: #ffffff;
    font-weight: 700;
    border: 1px solid #c9cfd4;

    .card-body {

        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        h3 {
            font-size: 16px;
        }
    }
}

.confirmed {
    color: #55CD6C;
}

.details {
    font-weight: 700;

    .cost {
        &:before {
            content: '$ ';
        }
    }
}

.btn-primary {
    display: block;
    margin: 0 auto;
}



    .dark-theme {
        h3 {
            color: #EDEEEF;
        }

        .container-fluid .card {
            &.card-confirm-success {
                background-color: #55cd6c !important;
            }
            .card-body {
                background-color: transparent;
            }
        }
    }

</style>
